import { render, staticRenderFns } from "./page-loading-new.vue?vue&type=template&id=180c0e43&"
import script from "./page-loading-new.vue?vue&type=script&lang=ts&"
export * from "./page-loading-new.vue?vue&type=script&lang=ts&"
import style0 from "./page-loading-new.vue?vue&type=style&index=0&id=180c0e43&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports